<template>
  <div class="searchRascunho">
    <div v-if="result !== null"
         class="py-1 py-sm-3">
      <SearchCard v-for="item in items"
                  :key="item.registro_id"
                  :rascunho="true"
                  class="mb-3"
                  :check="item.check"
                  :data-info="item"
                  :prop-segunda-via="propSegundaVia"
                  @onExcludeAll="excludeAll"
                  @onUpdateSearch="updateSearch"
                  @onSelectCard="selectCard" />
    </div>
    <ResultOptions v-if="result !== null"
                   :updated="result"
                   :exclude-all="(cardsSelected.length > 3 || cardsSelected.length > (items.length - 1))"
                   :last-page="lastPage"
                   :list-for-exclude="cardsSelected"
                   :order-by="false"
                   :page="page"
                   :rascunho="true"
                   @onNextPage="nextPage"
                   @onPreviousPage="previousPage"
                   @onSetPage="(page) => setPage(page)"
                   @onUpdateOrder="(order) => {orderBy = order}"
                   @onSelectAll="selectAllCards"
                   @onExcludeAll="excludeAll"
                   @onUpdateSearch="updateSearch" />
  </div>
</template>

<script>

  /* components */
  import ResultOptions from "@/components/SofiaRei/Busca/ResultOptions.vue"
  import SearchCard from "@/components/SofiaRei/Busca/SearchCard.vue"

  /* services */
  import BuscaService from "@/services/BuscaService"

  /* utils */
  import {transformSearchedRascunho} from "@/utils/itemRascunho"

  /* helpers */
  import {compType, order} from "@/helpers/orders"

  export default {
    name: "SearchRascunho",
    components: {
      SearchCard,
      ResultOptions,
    },
    props: {
      dataInfo: { type: Object, default: () => ({}) },
      check: { type: Boolean, default: false },
      rascunho: { type: Boolean, default: false },
      propRascunho: { type: Object, default: () => ({}) },
      propSegundaVia: {type: Boolean, default: false }
    },
    data () {
      return {
        result: null,
        items: [],
        orderBy: '',
        page: 0,
        lastPage: 0,
        params: {},
        cardsSelected: [],
        searchParams: {},
      }
    },
    mounted () {
      this.search(this.propRascunho)
    },
    methods: {
      nextPage () {
        if (this.page !== this.lastPage) this.page++
        this.updateSearch()
      },
      previousPage () {
        if (this.page !== 1) this.page--
        this.updateSearch()
      },
      setPage (page) {
        this.page = page
        this.updateSearch()
      },
      selectAllCards (isAllSelected) {

        this.items = this.items.map(item => {
          item.check = isAllSelected
          return item
        })

        this.items = order(
          this.result.data,
          this.orderBy === null
            ? "registro_id"
            : compType(
              this.propRascunho.searchParams.tipo_livro,
              "nascimento.nome_registrado",
              "casamento.nome_registrado_1",
              "obito.nome_registrado"
            )
        )
        this.cardsSelected = this.items.filter(item => {
          if (item.check) return item
        })
      },
      excludeAll () {
        this.cardsSelected = []
        this.updateSearch(1)
      },
      async updateSearch (page) {
        try {
          this.cardsSelected = []
          loader({ active: true })
          this.params = this.propRascunho.searchParams
          this.params.page = page ? page : this.page

          const params = {
            ...this.params,
            cartorio_id: this.$store.state.auth.cartorio_id
          }

          if (!!this.orderBy) {
            Object.assign(params, { orderby: this.orderBy })
          }

          let result = { data: [] }

          if ((params.orderBy !== "NOME" && params.orderBy != null) || !this.orderBy) {
            Object.assign(params, { orderby: 'RECENTES' })
          }

          const { data } = await BuscaService.searchRascunhoREI(params)

          if (data.docs) {
            result.data = data.docs.map((item) => transformSearchedRascunho(item))
          }

          result.page = data.page
          result.total = data.total
          result.perPage = 3
          result.lastPage = data.pages

          if (result) {

            if (!result.data.length) {
              this.result = null
              this.page = 1
              this.lastPage = 1
              objSwal.info.title = ''
              objSwal.info.text = 'Os rascunhos foram todos deletados'
              objSwal.info.html = ''
              return Swal.fire(objSwal.info)
            }

            this.result.data = result.data.map(item => {
              item.check = false
              return item
            })

            this.cardsSelected = result.data.filter(item => {
              if (item.check) return item
            })

            this.page = result.page
            this.lastPage = result.lastPage
            this.items = result.data || []
          }
        } finally {
          loader({ active: false })
        }
      },
      selectCard (value) {
        let indResult = this.items.indexOf(value)

        if (!this.cardsSelected.includes(value)) {
          this.cardsSelected.push(value)
          this.items[indResult].check = true
        } else {
          let ind = this.cardsSelected.indexOf(value)
          this.cardsSelected.splice(ind, 1)
          this.items[indResult].check = false
        }
      },
      search (result) {
        this.cardsSelected = []
        this.clearSearch()
        this.result = result

        this.items = result.data || []
        this.items.map(item => item.tipo_registro === this.propRascunho.searchParams.tipo_livro)

        this.page = result.page
        this.lastPage = result.lastPage
      },
      clearSearch () {
        this.result = null
        this.page = 1
      }
    }
  }
</script>

<style lang="scss">
@import "../../../scss/_utilities/exports";

.searchRascunho {
  background-color: $color-white;
  box-shadow: 0 0 pxToRem(4) $color-gray;
  min-height: pxToRem(68);
  transition: all 0.15s linear;
  padding-bottom: pxToRem(24);
  position: relative;

  .btn.disabled, .btn:disabled {
    opacity: 0.35;
  }

  &--bloqueado {
    width: 345px;
  }

  .tagRascunho {
    background-color: $color-dark;
    font-weight: 500;
    text-align: center;
    width: pxToRem(110);
    padding-top: pxToRem(8);
    margin-right: pxToRem(7);
    padding-left: pxToRem(4);
    border-top-left-radius: pxToRem(20) 50%;
    border-bottom-left-radius: pxToRem(20) 50%;
  }

  &_header {
    background-color: $color-light-blue;
    color: $color-white;
    padding: pxToRem(4) pxToRem(8);
  }

  &_openDetails {
    background-color: rgba($color-dark, 0.2);
    border: none;
    cursor: pointer;
    bottom: 0;
    left: 0;
    max-height: pxToRem(20);
    right: 0;
    transition: background-color 0.15s linear;

    &_icon {
      outline: none;
      vertical-align: baseline;
    }

    &:hover,
    &:focus {
      background-color: rgba($color-dark, 0.4);
      outline: none;

      .searchRascunho_openDetails_icon {
        fill: $color-white;
        transition: transform 0.15s linear;
      }
    }
  }

  &--open {
    .searchRascunho_openDetails_icon {
      @include transform(rotate(-180deg));
    }
  }

  &.type--obito {
  }

  &.type--casamento {
  }

  &.type--nascimento {
  }

  @media (min-width: pxToRem(568)) {
  }

  @media (min-width: pxToRem(768)) {
  }
}

.miniBoxInfo {
  color: white;
  display: inline-block;
  font-size: pxToRem(14);
  padding: 0 0 0 pxToRem(24);
  position: relative;

  &:before {
    background: no-repeat center center;
    background-size: cover;
    bottom: 0;
    content: "";
    display: inline-block;
    height: pxToRem(16);
    left: pxToRem(4);
    margin-top: pxToRem(2);
    position: absolute;
    top: 0;
    width: pxToRem(16);
  }

  &--averb,
  &--image {
    @extend .miniBoxInfo;
  }

  &--averb {
    &:before {
      background-image: url("../../../assets/icons/note.svg");
    }

    &.hasentAverb {
      color: $color-aqua;

      &:before {
        background-image: url("../../../assets/icons/note-inactive.svg");
      }
    }
  }

  &--image {
    &:before {
      background-image: url("../../../assets/icons/file-image.svg");
    }

    &.hasentFiles {
      color: $color-aqua;

      &:before {
        background-image: url("../../../assets/icons/file-image-inactive.svg");
      }
    }
  }
}
.transporteCircle {
    width: 22px;
    line-height: 22px;
    border-radius: 50%;
    text-align: center;
    font-weight: 800;
    background-color: #004e86;
    border: 2px solid #004e86;
}
</style>
